import { render, staticRenderFns } from "./PercentageResidential.vue?vue&type=template&id=0186fbec"
import script from "./PercentageResidential.vue?vue&type=script&lang=js"
export * from "./PercentageResidential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports